import customerEmailRoutes from "./customer_email";
import dashboardEmailRoutes from "./dashboard_email";
import taskRoutes from "./task";
import insuranceRoutes from "./insurance";
import automationsRoutes from "./automations";
import dashboardRoutes from "./dashboard";
import customerAnalysisRoutes from "./analysis";

import {
  mapAutomationsRoutes,
  mapCustomerAnalysisRoutes,
  mapCustomerEmailRoutes,
  mapDashboardRoutes,
  mapInsuranceRoutes,
  mapTaskRoutes,
} from "../mapping";

// Define the routes here
const routes = [
  ...mapInsuranceRoutes(insuranceRoutes),
  ...mapTaskRoutes(taskRoutes),
  ...mapAutomationsRoutes(automationsRoutes),
  ...mapDashboardRoutes(dashboardRoutes),
  ...mapDashboardRoutes(dashboardEmailRoutes),
  ...mapCustomerEmailRoutes(customerEmailRoutes),
  ...mapCustomerAnalysisRoutes(customerAnalysisRoutes),
];

export default routes;
